import { render, staticRenderFns } from "./TaskList.component.vue?vue&type=template&id=53905576&scoped=true&"
import script from "./TaskList.component.vue?vue&type=script&lang=js&"
export * from "./TaskList.component.vue?vue&type=script&lang=js&"
import style0 from "./TaskList.component.vue?vue&type=style&index=0&id=53905576&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53905576",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VIcon,VSpacer,VSubheader,VTooltip})
